<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {sdtAppLogin} from '@/api/interface/home'
    export default{
        name: 'app',
        methods:{
          login(){
            
          }
        },
        mounted() {
          console.log(window);
            if(window.debug){
              const user = {
                userId: window.debug_userId,
                userName: window.debug_userName,
                postType: window.debug_postType,
                regionCode: window.debug_regionCode,
                orgCode: window.debug_orgCode,
                orgName: window.debug_orgName,
              }
              if(user.postType == 'LD'){
                this.$router.replace('statistics');
              }
              console.log(user);
              this.$store.commit('setUser', user);
              window.localStorage.setItem('bbdb', JSON.stringify(user));

            }else{
            // 单点登录流程
            // 山东通单点登录
            const href = location.href
            let code = new Map()
            // 如果未夹杂参数则按原本业务流程执行
            href.split('?')[1].split('&').forEach(item => {
              const temp = item.split('=')
              code.set(temp[0], temp[1])
            });
            console.log(code);
            const instance = sdtAppLogin({
              code: code.get('code') || ""//获取编码
            })
            instance
            .then((result) => {
              const userInfo=JSON.parse(result.data.userInfo)
              const user = {
                userId: userInfo.ID,
                userName: userInfo.NAME,
                postType: '',
                regionCode: userInfo.REGION_CODE,
                orgCode: userInfo.ORG_CODE,
                orgName: userInfo.ORG_NAME,
              }
              if(userInfo.POSITION=='领导'){
                user.postType = 'LD';
              }else if(userInfo.POSITION=='科长'){
                user.postType = 'KZ';
              }else if(userInfo.POSITION=='科员'){
                user.postType = 'KY';
              }
              this.$store.commit('setUser', user);
              window.localStorage.setItem('bbdb', JSON.stringify(user));
              if(user.postType == 'LD'){
                this.$router.replace('statistics');
              }
            }).catch((err) => {
              console.log(err);
            });
            }

        },
    }
</script>
<style lang="less">
* {
  box-sizing: border-box;
}
body {
  min-height: 100vh;
  background-color: #F5F6F7;
  line-height: 1.5;
  color: #333;
  font-family: 'Microsoft Yahei' !important;
}

#app {
  
}

</style>
